import { Controller } from '@hotwired/stimulus';

// Shows a fixed copy of content when the original scrolls below the viewport.
// Place data-controller="sticky-bottom" on a wrapper containing:
//   data-sticky-bottom-target="original"  – the inline element
//   data-sticky-bottom-target="fixed"     – the fixed clone (hidden by default)
export default class extends Controller {
  static targets = ['original', 'fixed'];

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (this.hasFixedTarget) {
          this.fixedTarget.classList.toggle('hidden', entry.isIntersecting);
        }
      },
      { threshold: 0 }
    );

    if (this.hasOriginalTarget) {
      this.observer.observe(this.originalTarget);
    }
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
